// extracted by mini-css-extract-plugin
export default {"fp-email-confirmation-content-wrapper":"fp-email-confirmation-content-wrapper-881e","email-sent-confirmation-button":"email-sent-confirmation-button-77e8"};